export type PostEmployeeProfessionApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostEmployeeProfessionApiArg = {
  body: {
    description: string;
  } | null;
};
export type GetEmployeeProfessionApiResponse =
  | /** status 200 Standard response */ ({
      description?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeProfessionApiArg = {
  /** Name */
  id: string;
};
export type DeleteEmployeeProfessionApiResponse = unknown;
export type DeleteEmployeeProfessionApiArg = {
  /** Name */
  id: string;
};
export type PatchEmployeeProfessionApiResponse = unknown;
export type PatchEmployeeProfessionApiArg = {
  /** Name */
  id: string;
  body: {
    description: string;
  } | null;
};
export type PostEmployeeProfessionSetAsActiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeProfessionSetAsActiveApiArg = {
  /** Name */
  professionId: string;
};
export type PostEmployeeProfessionSetAsInactiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PostEmployeeProfessionSetAsInactiveApiArg = {
  /** Name */
  professionId: string;
};
export type GetEmployeeWorkProfessionsListApiResponse =
  | /** status 200 Standard response */ ({
      professions?: ({
        id?: string | null;
        description?: string | null;
        isActive?: boolean | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
